@import "../../utils/error-message.css";

:host {
  display: block;
  font-family: var(--ls-font-family);
}

.ls-reset-steering {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ls-reset-steering-gap, 0.5rem);
  position: relative;
  overflow: hidden;
}

.title {
  font-size: var(--ls-reset-steering-title-font-size, var(--ls-text-base));
  font-weight: var(--ls-reset-steering-title-font-weight, 600);
  color: var(--ls-reset-steering-title-color, var(--ls-font-primary-color));
}

.buttons,
.confirm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ls-reset-steering-buttons-gap, 0.5rem);
}

.confirm-question {
  font-size: var(--ls-text-sm);
  font-weight: 500;
  color: var(
    --ls-reset-steering-confirm-question-color,
    var(--ls-font-primary-color)
  );
}

.reset-button {
  font-family: inherit;
  font-size: var(--ls-reset-steering-button-font-size, var(--ls-text-sm));
  font-weight: 500;
  padding: var(--ls-reset-steering-button-padding, 0.5rem 1rem);
  border: none;
  border-radius: var(--ls-reset-steering-button-border-radius, 0.375rem);
  color: var(--ls-reset-steering-button-color, #ffffff);
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.reset-button.idle {
  background-color: var(--ls-reset-steering-idle-bg, var(--ls-primary-color));
}

.reset-button.force {
  background-color: var(
    --ls-reset-steering-force-bg,
    var(--ls-secondary-color)
  );
  color: var(
    --ls-reset-steering-force-color,
    var(--ls-reset-steering-button-color, #ffffff)
  );
}

.reset-button.cancel {
  background-color: var(--ls-reset-steering-cancel-bg, transparent);
  color: var(--ls-reset-steering-cancel-color, var(--ls-font-primary-color));
}

.reset-button:hover:not(:disabled) {
  opacity: 0.85;
}

.reset-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.notice {
  margin: 0;
  font-size: var(--ls-text-sm);
  color: var(--ls-reset-steering-notice-color, var(--ls-gray-500));
}

.feedback {
  font-size: var(--ls-reset-steering-feedback-font-size, var(--ls-text-xs));
  font-weight: 500;
  color: var(--ls-reset-steering-feedback-color, var(--ls-font-primary-color));
}

.ls-reset-steering .blur {
  pointer-events: none;
}

.ls-reset-steering .error-message {
  font-size: var(--ls-text-sm);
  line-height: 1.3;
  text-align: center;
  padding: 0.25rem 0.5rem;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
}
